export function credentialsServerModel(data) {
  return {
    UserName: data.userName || "",
    Password: data.newPassword || ""
  };
}
